import {grey} from "@mercedes-benz/mbui-theme";

const styles = ({ theme }) => ({
    '&': {
        position: 'relative',
        padding: `${theme.spacing(4)} ${theme.spacing(4)} ${theme.spacing(2)} ${theme.spacing(4)}`,
        display: 'flex', 
        flexDirection:'column', 
        alignItems: 'center',
        width: '100%',

        [theme.breakpoints.up('sm')]: {
            
            marginLeft: 0,
        },

        [theme.breakpoints.up('md')]: {
            padding: `${theme.spacing(3)} ${theme.spacing(3)} ${theme.spacing(2)} ${theme.spacing(3)}`,
            opacity: '95%',
            width: '33%',
            marginLeft: `${theme.spacing(3)}`,
        },

        [theme.breakpoints.up('lg')]: {
            marginLeft: `${theme.spacing(6)}`,
        }
    },
    '& .ConfigArea-headline': {
        display: 'none',

        [theme.breakpoints.up('sm')]: {
            marginBottom: theme.spacing(2),
            display: 'block',
        }
    },
    '& .ConfigArea-controls, .ConfigArea-options': {
        width: '100%'
    },
    '& .ConfigArea-controls': {
        marginTop: `-${theme.spacing(2)}`,
        marginBottom: `${theme.spacing(2)}`,

        [theme.breakpoints.up('md')]: {
            marginTop: `-${theme.spacing(2)}`,
            marginBottom: `${theme.spacing(6)}`,
        }
    },
    '& .ConfigArea-controls-print': {
        display: 'none',
        marginBottom: theme.spacing(4),

        '& .ConfigArea-control': {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
        }
    },
    '& .ConfigArea-cta': {

        '.MuiButton-root': {
            lineHeight: '1.675rem',
            fontSize: '.875rem',
        },
        '.cta-print': {
            width: '100%',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            fontSize: '1.1rem',
        },
    },
    '& .ConfigArea-control': {
        marginTop: theme.spacing(2),

        '.Slider-stack': {
            margin: `0 calc(-12px - ${theme.spacing(1.5)})`,
        },

        '.MuiSlider-thumb': {
            width: '10px',
            height: '10px',
        },

        '.MuiIconButton-root': {
            padding: `2px ${theme.spacing(1.5)}`,
        },

        '.MuiTypography-root': {
            lineHeight: '1.75rem'
        },    
        '.MuiSlider-root': {
            padding: '1rem 0',
            marginBottom: '1.25rem',
        },
        '.MuiSlider-markLabel': {
            top: '2rem'
        },
        '.MuiSlider-valueLabel': {
            transform: 'translateY(100%) scale(0)',
            bottom: '-10px',
            top: 'unset',
            transformOrigin: 'top center',
        }, 
        '.MuiSlider-valueLabel.MuiSlider-valueLabelOpen': {
            transform: 'translateY(100%) scale(1)',
            
        },
        '.MuiSlider-valueLabel::before': {
            transform: 'translate(-50%, -50%) rotate(45deg)',
            bottom: 'unset',
            top: '0',
        }
    },
    '&.MuiPaper-elevation1': {
        zIndex: '100'
    },
    '&.MuiPaper-elevation2': {
        zIndex: '200'
    },
    '&.MuiPaper-elevation3': {
        zIndex: '300'
    },
    '.ConfigArea-options': {
        display: 'none',

        '.MuiCheckbox-root': {
            padding: '6px 8px',
        },
        '.MuiFormControlLabel-root': {
            marginLeft: `-10px`
        },
        '.MuiTypography-body1': {
            lineHeight: '1.25rem'
        }
    },
    '.ConfigArea-options,.ConfigArea-controls-print': {
        '.MuiTypography-h4': {
            fontSize: '1.375rem',
            lineHeight: '1.75rem',
            marginBottom: '0.5rem'
        }
    },
    '& .ConfigArea-calc': {
        borderTop: `1px solid ${grey[80]}`,
        borderBottom: `1px solid ${grey[80]}`,
        width: `calc(100% + ${theme.spacing(6)})`,
        height: `242px`,
        padding: `${theme.spacing(3)} ${theme.spacing(3)}`,
        position: 'relative',
        top: '0',
        left: `0`,
        right: `0`,
        marginBottom: `${theme.spacing(2)}`,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',

        '.MuiTypography-h3': {
            lineHeight: '1',
            fontSize: '2.25rem'
        },
        '.MuiTypography-body1': {
            lineHeight: '1rem'
        },
    },

    '.ConfigArea-controls-print': {
        marginTop: 0,
    },
});

export default styles